
import { defineComponent } from 'vue'
import NavBar from '@/components/layout/nav/NavBar.vue'

export default defineComponent({
  name: 'App',

  components: {
    NavBar
  }
})
